<template>
  <el-dialog
    title="权益折扣"
    :visible.sync="visible"
    :before-close="handleClose"
    append-to-body
  >
    <el-form
      ref="formRef"
      :model="formInfo"
      label-width="120px"
      label-position="right"
      size="small"
      v-loading="loading"
      :rules="formRules"
    >
      <el-form-item label="折扣名称" prop="name">
        <el-input
          v-model="formInfo.name"
          placeholder="折扣名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="权益名称" prop="privilegeName">
        <el-input
          v-model="formInfo.privilegeName"
          placeholder="权益名称"
          clearable
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="权益code" prop="privilegeCode">
        <el-input
          v-model="formInfo.privilegeCode"
          placeholder="权益code"
          clearable
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="折扣开始区间" prop="begin">
        <el-input
          v-model="formInfo.begin"
          placeholder="折扣开始区间"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="折扣结束区间" prop="end">
        <el-input
          v-model="formInfo.end"
          placeholder="折扣结束区间"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="权益折扣" prop="discount">
        <el-input
          v-model="formInfo.discount"
          placeholder="权益折扣"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { bizPrivilegeDiscountSave } from "@/api/privilege";
export default {
  name: "PrivilegeDiscount",
  data() {
    return {
      visible: false,
      loading: false,
      formInfo: {},
      formRules: {
        name: [{ required: true, message: "请输入折扣名称", trigger: "blur" }],
        begin: [
          { required: true, message: "请输入折扣开始区间", trigger: "blur" }
        ],
        end: [
          { required: true, message: "请输入折扣结束区间", trigger: "blur" }
        ],
        discount: [
          { required: true, message: "请输入权益折扣", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    open(formInfo) {
      console.log("formInfo");
      this.visible = true;
      this.formInfo = formInfo;
    },
    handleClose() {
      this.visible = false;
      this.$refs.formRef.resetFields();
      this.formInfo = {};
    },
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.saveFormData();
        }
      });
    },
    saveFormData() {
      this.loading = true;
      bizPrivilegeDiscountSave(this.formInfo)
        .then(resp => {
          if (resp.data.status == 100) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.handleClose();
            this.$emit("refresh");
          } else {
            this.$message.error(resp.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// discount.vue?0eb38ce0